exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".globalLoader___3GspZ {\n  position: absolute;\n  top: calc(50% - 64px);\n  left: calc(50% - 64px); }\n  .globalLoader___3GspZ i {\n    font-size: 48px; }\n", ""]);

// Exports
exports.locals = {
	"globalLoader": "globalLoader___3GspZ"
};